import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";

/** A strip under the top bar for things that affect the whole page (offline, a wait, the session lapsing). */
export function Banner({ icon, tone, children, action }: { icon: IconName; tone: "err" | "flag" | "info"; children: ReactNode; action?: ReactNode }) {
  return (
    <div className={`banner ${tone}`} role={tone === "err" ? "alert" : "status"}>
      <div className="banner-in">
        <Icon n={icon} />
        <span className="banner-text">{children}</span>
        {action}
      </div>
    </div>
  );
}
